import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Field } from 'react-final-form';
import { validations } from '@unite-us/app-components';
import { DateField } from '@unite-us/ui';
import { now } from 'src/common/utils/today';
import { formatDateMMDDYYYY } from 'src/common/utils/Dates/formatDate';

const getMaxDateForOpenedDate = (exitedAtValue) => {
  const exitedAt = moment.unix(exitedAtValue).utc();
  if (!exitedAt.isValid()) {
    return now();
  }
  return exitedAt.isSame(moment(), 'day') ? now() : formatDateMMDDYYYY(exitedAt);
};

const getMinDateForExitedAt = (openedDateValue) => {
  const openedDate = moment.unix(openedDateValue).utc();
  return openedDate.isValid() ? formatDateMMDDYYYY(openedDate.subtract(1, 'day')) : null;
};

const DateFields = ({
  minDate,
  minOpenedDate,
  showExitedAtField,
  showOpenAndClosedDateInputs,
  values,
}) => {
  if (showOpenAndClosedDateInputs) {
    return (
      <div className="date-div">
        <Field name="opened_date">
          {(params) => (
            <DateField
              id="openedDateInput"
              label="Opened Date"
              inline={false}
              maxDate={getMaxDateForOpenedDate(values.exited_at)}
              minDate={minOpenedDate}
              required
              {...params}
              validations={validations.isRequired}
            />
          )}
        </Field>
        <Field name="exited_at">
          {(params) => (
            <DateField
              id="exitDateInput"
              label="Closed Date"
              inline={false}
              required
              maxDate={moment().utc().format('MM/DD/YYYY')}
              minDate={getMinDateForExitedAt(values.opened_date) || minDate}
              customErrorMessage="Closed date cannot be later than today or before opened date"
              {...params}
              validations={validations.isRequired}
            />
          )}
        </Field>
      </div>
    );
  }

  if (!showExitedAtField) {
    return null;
  }

  return (
    <Field name="exited_at">
      {(params) => (
        <DateField
          id="exitDateInput"
          label="Closed Date"
          inline={false}
          required
          maxDate={moment().utc().format('MM/DD/YYYY')}
          minDate={getMinDateForExitedAt(values.opened_date) || minDate}
          customErrorMessage="Closed date cannot be later than today or before opened date"
          {...params}
          validations={validations.isRequired}
        />
      )}
    </Field>
  );
};

DateFields.propTypes = {
  minDate: PropTypes.string,
  minOpenedDate: PropTypes.string,
  showExitedAtField: PropTypes.bool.isRequired,
  showOpenAndClosedDateInputs: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
};

DateFields.defaultProps = {
  minDate: null,
  minOpenedDate: null,
};

export default DateFields;
